/**
 * Creates a srcset for an image URL.
 */
export function createSrcSet(originalUrl: string, maxWidth = 1600) {
  // Shopify sometimes gives us a URL without a protocol, so we need to add one
  const hasProtocol =
    originalUrl.startsWith('http://') || originalUrl.startsWith('https://');
  const url = new URL(
    hasProtocol ? originalUrl : `${window.location.protocol}${originalUrl}`
  );
  const sizes = [100, 200, 400, 600, 800, 1000, 1200, 1400, 1600].filter(
    (size) => size <= maxWidth
  );
  return sizes
    .map((size) => {
      url.searchParams.set('width', size.toString());
      return `${url.toString()} ${size}w`;
    })
    .join(', ');
}
